
const options = (handleOpenPopin, openedConversation, t) => {
  const isOneToOneChat = openedConversation && openedConversation.active_users.length === 2
  const items = []
  if (openedConversation) {
    const isActiveMember =
      openedConversation.conversation.isLeftByUser === 0 && openedConversation.conversation.hasBeenRemoved === 0

    if (!isOneToOneChat && openedConversation && isActiveMember) {
      items.push({
        text: t('messenger.header.manageMembers'),
        icon: 'contact',
        onClick: () => handleOpenPopin('manage-members'),
      })
      items.push({
        text: t('messenger.header.renameConversation'),
        icon: 'edit',
        onClick: () => handleOpenPopin('rename-conversation'),
      })
      items.push({
        text: t('messenger.header.leaveConversation'),
        icon: 'logout',
        onClick: () => handleOpenPopin('leave-conversation'),
      })
    }

    if (
      !isOneToOneChat &&
      openedConversation &&
      isActiveMember &&
      openedConversation.conversation.user_is_conversation_admin === 1
    ) {
      items.push({
        text: t('messenger.header.deleteConversation'),
        icon: 'delete',
        onClick: () => handleOpenPopin('delete-conversation'),
      })
    }

    if (openedConversation && isActiveMember) {
      if (openedConversation.conversation.isMutedByUser === 1) {
        items.push({
          text: t('messenger.header.unmuteConversation'),
          icon: 'mute',
          onClick: () => handleOpenPopin('unmute-conversation'),
        })
      } else {
        items.push({
          text: t('messenger.header.muteConversation'),
          icon: 'mute',
          onClick: () => handleOpenPopin('mute-conversation'),
        })
      }
    }
  }
  return items;
}

export default options
